/* @moldura padrao */
/**
 * artigo.tsx — Leitura de um artigo da Central de Ajuda (`/ajuda/:slug`).
 * Renderiza o markdown do artigo; o blockquote (Dica) vira um alert do tema.
 */
import { useNavigate, useParams } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import type { Components } from 'react-markdown';
import { getArtigo } from './artigos';
import { CustomMolduraPagina } from '@/components/CustomMolduraPagina';

const MD: Components = {
  h2: ({ children }) => <h5 className="text-theme-1 mt-4 mb-2">{children}</h5>,
  ol: ({ children }) => <ol className="ps-3 mb-3 lh-lg">{children}</ol>,
  ul: ({ children }) => <ul className="ps-3 mb-3 lh-lg">{children}</ul>,
  p: ({ children }) => <p className="mb-3">{children}</p>,
  blockquote: ({ children }) => (
    <div className="alert alert-info d-flex gap-2" role="note">
      <i className="bi bi-lightbulb-fill flex-shrink-0"></i>
      <div className="ajuda-dica">{children}</div>
    </div>
  ),
};

export function AjudaArtigoPage() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const artigo = slug ? getArtigo(slug) : undefined;

  if (!artigo) {
    return (
      <div className="container py-3">
        <div className="alert alert-warning">
          Este artigo ainda não foi escrito.
        </div>
        <button className="btn btn-link px-0" onClick={() => navigate('/ajuda')}>
          <i className="bi bi-arrow-left me-1"></i> Voltar à Central de Ajuda
        </button>
      </div>
    );
  }

  return (
    /* O BREADCRUMB DESTA TELA ERA ESCRITO À MÃO — a única do app que tinha um,
       e por isso o único que existia antes da moldura. Agora é o da moldura: o
       `Início` entra sozinho, a seção vira o elo do meio e o título fecha. */
    <CustomMolduraPagina
      titulo={artigo.titulo}
      descricao={artigo.secao}
      caminho={[{ rotulo: 'Ajuda', para: '/ajuda' }]}
    >

      <div className="row">
        <div className="col-lg-8">
          <div className="card adminuiux-card">
            <div className="card-body p-4">
              <h4 className="mb-3">{artigo.titulo}</h4>
              <ReactMarkdown components={MD}>{artigo.md}</ReactMarkdown>
              <hr className="my-4" />
              <button
                className="btn btn-link px-0"
                onClick={() => navigate('/ajuda')}
              >
                <i className="bi bi-arrow-left me-1"></i> Voltar à Central de Ajuda
              </button>
            </div>
          </div>
        </div>
      </div>
    </CustomMolduraPagina>
  );
}
